<app-head-generative-ai selectedNavItem="resources"></app-head-generative-ai>

<app-tabs-resources-generative-ai
  selectedTabItem="policies-and-initiatives"
></app-tabs-resources-generative-ai>

<div class="container">
  <ng-container *ngIf="!loader">
    <div class="columns is-multiline" *ngIf="featuredCards?.length">
      <div
        class="column is-4-tablet is-3-desktop"
        *ngFor="let featuredCard of featuredCards"
      >
        <app-featured-card
          [featuredCard]="featuredCard"
          [layout]="FeaturedCardLayout.Vertical"
        ></app-featured-card>
      </div>
    </div>

    <div class="columns flex flex-wrap" *ngIf="!featuredCards.length">
      <div class="column is-12-mobile is-4-tablet">
        <p>No policies and initiatives found.</p>
      </div>
    </div>
  </ng-container>

  <!-- Loader Policies and initiatives -->
  <div class="columns is-multiline" *ngIf="loader">
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="column is-12-mobile is-4-tablet is-3-desktop">
      <div class="lc lc--regular">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
